
	import Vue from 'vue';
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import SkinAutocomplete from "@/components/skin/SkinAutocomplete.vue";
	import SkinAvatar from "@/components/skin/SkinAvatar.vue";
	import {ISkin} from "@/models/ISkin";
	import ItemAutocomplete from "@/components/item/ItemAutocomplete.vue";

	@Component({
		components: {ItemAutocomplete, SkinAvatar, SkinAutocomplete}
	})
	export default class SkinSetItemDialog extends Vue {

		@Prop({type: Boolean, default: false})
		public open!: boolean;

		@Prop({type: Object, required: true})
		public skin!: ISkin;

		private loading: boolean = false;
		private itemId: number | null = null;

		private reset(): void {
			this.itemId = this.skin.item_id;
		}

		private trySave(): void {
			this.loading = true;
			this.$store.dispatch('skin/setItem', {id: this.skin.id, itemId: this.itemId})
				.then(() => this.save(this.itemId))
				.finally(() => this.loading = false);
		}

		@Watch('skin.item_id', {immediate: true})
		private onSkinItemIdChanged(): void {
			this.reset();
		}

		@Watch('open')
		private onOpenChanged(value: boolean): void {
			if (!value) this.reset();
		}

		@Emit('cancel')
		public cancel(): void {
			//do nothing
		}

		@Emit('save')
		public save(itemId: number | null): number | null {
			return itemId;
		}

	}
